import _ from 'lodash';

class TableGridBodyController {
  constructor($scope, $compile, $element, stringUtilsService) {
    this.name = 'tableGridBody';
    this.$scope = $scope;
    this.$compile = $compile;
    this.$element = $element;
    this.stringUtilsService = stringUtilsService;
    this.unbound = true;
    this.justSorted = false;
    this.doneScrolling = false;
    this.renderedRowIds = new Set();
    this.setRowType();
    this.watchData();
    this.watchSortBy();
    this.watchSearchValue();
    this.configureInfiniteScroll();
  }

  setRowType() {
    this.rowType = (this.$scope.rowOptions && this.$scope.rowOptions.name) ? this.$scope.rowOptions.name : 'table-grid-row';
  }

  watchData() {
    this.$scope.$watch('data', this.bindData.bind(this));
  }

  watchSearchValue() {
    this.$scope.$watch('searchValue', this.resetTbody.bind(this));
  }

  watchSortBy() {
    this.$scope.$watch('sortBy', this.resetTbody.bind(this), true);
  }

  configureInfiniteScroll() {
    this.$element.on('scroll', this.onScroll.bind(this));
  }

  onScroll() {
    if (this.shouldPaginate()) {
      this.previousScrollHeight = this.$element[0].scrollHeight;
      this.$scope.getNextSetOfRowsToFetch();
    }
  }

  shouldPaginate() {
    return (!this.justSorted && !this.doneScrolling && this.scrollHeightChanged() && this.endOfScrollReached());
  }

  scrollHeightChanged() {
    return (this.$element[0].scrollHeight !== this.previousScrollHeight);
  }

  endOfScrollReached() {
    return (this.$element[0].scrollTop + this.$element[0].offsetHeight + 1) >= this.$element[0].scrollHeight;
  }

  unbindData() {
    this.unbound = true;
    this.justSorted = true;
    this.doneScrolling = false;
    this.renderedRowIds.clear();
    this.$element.empty();
  }

  resetTbody(newValue, oldValue) {
    if (newValue !== oldValue) {
      this.scrollToTop();
      this.unbindData();
      this.resetPreviousScrollHeight();
    }
  }

  scrollToTop() {
    this.$element.scrollTop = 0;
  }

  resetPreviousScrollHeight() {
    delete this.previousScrollHeight;
  }

  bindData(newValue, oldValue) {
    let newRows = _.differenceWith(newValue, oldValue, _.isEqual);
    let areNewRows = (newRows.length > 0);
    let rowsToBind = newValue;
    this.isDoneScrolling(areNewRows);
    this.touchTbody();

    //uncheck selecAll when we get new data
    if(areNewRows && this.$scope.isAllRowsSelected){
      this.$scope.isAllRowsSelected = false;
    }

    if (!this.doneScrolling) {
      this.bindRows(rowsToBind);
    }
  }

  touchTbody() {
    this.unbound = false;
    this.justSorted = false;
  }

  isDoneScrolling(areNewRows) {
    this.doneScrolling = (!areNewRows && !this.unbound);
  }

  generateUniqueRowId(row) {
    if (!row || typeof row !== 'object') return null;

    const ID_FIELDS = [
      'sectionId',
      'courseProductAssignmentId',
      'courseProductTitle',
      'courseResourceTitle',
      'sectionSourceSystemId',
      'sectionTitle',
      'classCode',
      'courseId',
      'id',
    ];

    const EXCLUDED_KEY_PREFIXES = ['$', '__', '_']; // remove '_' if your API legitimately uses underscore keys

    const hasValue = (v) => v !== undefined && v !== null && v !== '';
    const enc = (v) => encodeURIComponent(String(v).trim());
    const isExcludedKey = (k) => EXCLUDED_KEY_PREFIXES.some((p) => k.startsWith(p));

    const first5ReadablePrefixes = ID_FIELDS
      .filter((k) => hasValue(row[k]))
      .slice(0, 5)
      .map((k) => `${k}=${enc(row[k])}`)
      .join('|') || 'noid';

    const allStableKeysAvailableOnTheRow = Object.keys(row)
      .filter((k) => !isExcludedKey(k))
      .filter((k) => typeof row[k] !== 'function')
      .filter((k) => hasValue(row[k]))
      .sort();

    const stableData = {};
    for (const k of allStableKeysAvailableOnTheRow) stableData[k] = row[k];

    const canonical = this.stringUtilsService.stableStringify(stableData);
    if (!canonical) return null;

    const hash = this.stringUtilsService.computeStableHash(canonical);
    return `row:${first5ReadablePrefixes}|h:${hash}`;
  }

  buildRow(row) {
    // create a unique identifier for the row
    let rowId = this.generateUniqueRowId(row);

    // if no ID fields exists, create one based on index + partial data
    if (rowId === undefined || rowId === null) {
      let index = _.findIndex(this.$scope.data, row);
      rowId = `row-${index}-${JSON.stringify(row).slice(0, 50)}`;
    }

    // row has already been rendered, do not render it again
    if (this.renderedRowIds.has(rowId)) {
      return '';
    }
    // add the row's ID to the Set to mark it as rendered
    this.renderedRowIds.add(rowId);

    let index = _.findIndex(this.$scope.data, row);
    return `<tr class="table__table-row"
                ${this.rowType}
                ng-class="{changeClass: vm.data[${index}].isCreated || vm.data[${index}].isDeleted || vm.data[${index}].hasSchoolFilterChanged}"
                row-options="vm.rowOptions"
                row="vm.data[${index}]"
                columns="vm.columns"
                options="vm.options"
                rows-selected="vm.rowsSelected"
                fetch-results="vm.fetchResults()"
                meta-data="vm.metaData"></tr>`;
  }

  buildTemplateString(rows) {
    return rows.map((row) => { return this.buildRow(row); }).reduce((previous, current) => previous + current, '');
  }

  bindRows(rows) {
    let templateString = this.buildTemplateString(rows);
    let rowElements = this.$compile(angular.element(templateString))(this.$scope);
    this.$element.append(rowElements);
  }
}

TableGridBodyController.$inject = ['$scope', '$compile', '$element', 'stringUtilsService'];

export default TableGridBodyController;



// WEBPACK FOOTER //
// ./app/components/tableGridBody/tableGridBody.controller.js